import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useExtendAvisoObraFieldsConfig from './useExtendAvisoObraFieldsConfig';
import useFormValidation from '../../../hooks/useFormValidation';

export interface ExtendAvisoObraFormData {
    extensionDate: string;
    observation: string;
}

export const INITIAL_VALUES: ExtendAvisoObraFormData = {
    extensionDate: '',
    observation: ''
};

const useExtendAvisoObraForm = (selectedObra: any) => {
    const [formData, setFormData] = useState<ExtendAvisoObraFormData>(INITIAL_VALUES);
    const { t } = useTranslation('avisoObra');

    const { errors, hasValidationErrors, validateForm, handleBlurValidation, setErrors } =
        useFormValidation();

    const { fieldsConfig } = useExtendAvisoObraFieldsConfig({
        t,
        formData,
        handleBlurValidation,
        selectedObra
    });

    const handleChange = (name: string, value: any) => {
        setErrors((prevState) => ({
            ...prevState,
            [name]: { hasError: false, errorMessage: '' }
        }));
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };
    const resetForm = () => {
        setFormData(INITIAL_VALUES);
        setErrors({});
    };

    return {
        formData,
        errors,
        hasValidationErrors,
        fieldsConfig,
        handleChange,
        validateForm,
        resetForm
    };
};

export default useExtendAvisoObraForm;
